import $ from 'jquery';
import cvr from './components/cvr.js';
import representative from './components/representative';
import complainant from './components/complainant';
import modal from './components/modal';
import popper from './components/popper';
import sessionTimeout from './components/sessionTimeout';

global.$ = global.jQuery = $;

function initDynamicImports() {
    const $forms = $('.js-form');
    if ($forms.length > 0) {
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        // TODO: report ReSharper bug
        import(/* webpackChunkName: "formSetup" */ '@/components/form.js').then((form) => {
            form.globalInit().then(function () {
                window.modalTimeouts = [];
                window.isLastActionClick = false;

                cvr.initEvents();
                complainant.initEvents();
                representative.initEvents();
                modal.initEvents();

                popper.init();

                $forms.each(function () {
                    form.init(this);
                });
            });
        });
    }

    if ($('form').length > 0) sessionTimeout.initEvents();
}

document.addEventListener('DOMContentLoaded', initDynamicImports);
